import { render, staticRenderFns } from "./dashboard.vue?vue&type=template&id=3539b8e9&scoped=true&"
import script from "./dashboard.vue?vue&type=script&lang=js&"
export * from "./dashboard.vue?vue&type=script&lang=js&"
import style0 from "./dashboard.vue?vue&type=style&index=0&id=3539b8e9&lang=scss&scoped=true&"
import style1 from "./dashboard.vue?vue&type=style&index=1&id=3539b8e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3539b8e9",
  null
  
)

export default component.exports